import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartBar, faCalendarAlt, faHospital, faUsers, faUserMd, faVideo, faUnlockAlt, faCog, faProcedures } from '@fortawesome/free-solid-svg-icons';

library.add(faChartBar, faCalendarAlt, faHospital, faUsers, faUserMd, faVideo, faUnlockAlt, faCog, faProcedures)